import React, { useState } from 'react';
import { usePlanLimits } from '@/hooks/usePlanLimits';
import { Lock, Crown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useProModal } from '@/contexts/ProModalContext';

interface ProGateProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  showLockIcon?: boolean;
  featureName?: string;
}

const ProGate: React.FC<ProGateProps> = ({ children, fallback, showLockIcon = true, featureName }) => {
  const { isPro } = usePlanLimits();
  const { t } = useTranslation();
  const { openProModal } = useProModal();

  if (isPro) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <div className="relative inline-block group cursor-pointer" onClick={(e) => { e.preventDefault(); e.stopPropagation(); openProModal(featureName); }}>
      <div className="opacity-50 pointer-events-none">
        {children}
      </div>
      {showLockIcon && (
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-background/50 rounded backdrop-blur-[1px]">
          <Lock className="h-5 w-5 text-amber-500 drop-shadow-md" />
        </div>
      )}
    </div>
  );
};

export default ProGate;
